import React, { Component } from 'react';
import { convertToMoney } from '../utils/formats';
import { formatearCodigo, textoVencimiento } from '../utils/giftCards';

// Se abre al confirmar una venta con gift cards (FR-005): el cajero copia cada código A MANO en
// una tarjeta de imprenta, así que van grandes, en grupos y en monoespaciada (para no confundir
// caracteres). La venta ya quedó registrada: cerrar el modal sólo navega a Ventas. Si el cajero
// lo cierra sin copiar, los códigos se vuelven a ver en Gift cards o en el detalle de la venta.
//
// Modal renderizado a mano (`display: block`), como el resto del backoffice: sin el JS de
// Bootstrap, `.modal` no scrollea, por eso el contenedor lleva `overflowY: auto`.
const MODAL = { display: 'block', background: 'rgba(0,0,0,.4)', overflowY: 'auto' };
const CODIGO = {
    fontFamily: 'SFMono-Regular, Menlo, Consolas, "Liberation Mono", monospace',
    fontSize: '2rem',
    fontWeight: 700,
    letterSpacing: '0.12em',
};

class GiftCardCodesModal extends Component {
    render() {
        const cards = this.props.cards || [];
        return (
            <div id="modal-gift-card-codes" className="modal" role="dialog" style={MODAL}>
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">
                                {cards.length === 1 ? 'Código de la gift card' : `Códigos de las ${cards.length} gift cards`}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <p className="text-muted mb-3">
                                Copiá cada código en su tarjeta antes de entregarla. Los guiones son sólo para leerlo:
                                el cliente puede escribirlo con o sin ellos.
                            </p>
                            <ul className="list-group">
                                {cards.map((card) => (
                                    <li key={card.id || card.code} className="list-group-item d-flex flex-wrap justify-content-between align-items-center">
                                        <span className="gift-card-code" style={CODIGO}>{card.display || formatearCodigo(card.code)}</span>
                                        <span className="text-right">
                                            {/* Un voucher de producto o de mesa no es plata: se muestra qué cubre. */}
                                            <strong>{card.kind && card.kind !== 'monto' ? (card.label || card.benefit) : `$ ${convertToMoney(Number(card.amount) || 0)}`}</strong>
                                            <br />
                                            <small className="text-muted">{textoVencimiento(card.validUntil)}</small>
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" onClick={this.props.onClose}>
                                Listo, ya los copié
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default GiftCardCodesModal;
